import { validationMixin } from 'vuelidate'
import {
  isValidPatternText, hasAnyEntity, splittedPatternsAny
} from '@/services/pattern/validation.service'
import { mapState } from 'vuex'

export const patternValidationMixin = {
  mixins: [validationMixin],

  computed: {
    ...mapState({
      $patternAnyEntities: state => state.knowledgebase.entities.patternAnyEntities
    })
  },

  validations () {
    return {
      value: {
        hasAnyEntity,
        isValidPatternText,
        splittedPatternsAny: (value) => splittedPatternsAny(value, this.$patternAnyEntities)
      }
    }
  },

  watch: {
    value () {
      this.$v.value.$touch()
    }
  }
}
